export enum EProjectStatus {
  BY_BUC = "by-buc",
  TOP_SOON = "top-soon",
  COMPLETED = "completed",
}
